import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { MobileActionBar } from "@/components/layout/MobileActionBar";
import { useLenis } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import Phones from "@/pages/Phones";
import ProductDetails from "@/pages/ProductDetails";
import Repair from "@/pages/Repair";
import SellYourPhone from "@/pages/SellYourPhone";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.35 }}
        className="pb-24 lg:pb-0"
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/phones" element={<Phones />} />
          <Route path="/phones/:slug" element={<ProductDetails />} />
          <Route path="/repair" element={<Repair />} />
          <Route path="/sell-your-phone" element={<SellYourPhone />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </motion.main>
    </AnimatePresence>
  );
}

export default function App() {
  useLenis();
  return (
    <BrowserRouter>
      <div className="grain min-h-screen">
        <ScrollToTop />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
        <MobileActionBar />
      </div>
    </BrowserRouter>
  );
}
